/**
 * Simple route utilities for authentication flow.
 */

/**
 * Public routes that don't require authentication (exact matches only)
 * Must match publicAuthRoutesConfig in routesConfig.js
 *
 * Note: Dynamic routes like /new-password/:token are handled by React Router
 * and should be added here as exact paths if needed for axios interceptors.
 * If we need dynamic route matching, create a separate DYNAMIC_PUBLIC_ROUTES config.
 */
const PUBLIC_ROUTES = [
  '/',
  '/login',
  '/customer/register',
  '/forgot-password',
  '/verify-otp',
];
/**
 * Check if the current location is a public route
 *
 * SECURITY: Uses exact matching to prevent false positives like /login-admin matching /login
 *
 * @param {string} [pathname] - Optional pathname to check (defaults to window.location.pathname)
 * @returns {boolean}
 */
export const isPublicRoute = (pathname) => {
  const currentPath =
    pathname || (typeof window !== 'undefined' ? window.location.pathname : '');

  // Simple exact match only - no dynamic route handling
  // Dynamic routes like /new-password/:token are handled by React Router
  return PUBLIC_ROUTES.includes(currentPath);
};

/**
 * Check if the current location is a login route
 * @param {string} [pathname] - Optional pathname to check
 * @returns {boolean}
 */
export const isLoginRoute = (pathname) => {
  const currentPath =
    pathname || (typeof window !== 'undefined' ? window.location.pathname : '');
  return currentPath === '/login' || currentPath === '/';
};

/**
 * Check if current location should skip auth redirects on 401
 * @param {string} [pathname] - Optional pathname to check
 * @returns {boolean}
 */
export const shouldSkipAuthRedirect = (pathname) => {
  return isLoginRoute(pathname) || isPublicRoute(pathname);
};
